/**
 * Which project the shell is scoped to, read from the path.
 *
 * A layout route sees only its own params, and the shell sits above every
 * project route, so the slug is read from the location instead. Returns null
 * on account scope routes, which is what flips the rail to its short list.
 */

import { useLocation } from 'react-router';

export function useProjectSlug(): string | null {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] !== 'p' || !segments[1]) return null;
  return decodeURIComponent(segments[1]);
}
